export const environment = {
    production: false,
    apiUrl: "https://staging.strapi.tafel-tools.de/api",
    baseUrl: "https://staging.strapi.tafel-tools.de"
};